<template>
  <div class="box contaner" ref="wrap">
    <navBar title="书籍详情" :isDetail="true" color="#5F4C4C"></navBar>
    <!-- 书籍详情 -->
    <bookCover
      :bookInfo="bookInfo"
      :cataitem="cataitem"
      :isLastChapter="isLastChapter"
      @goRead="goRead"
    ></bookCover>
    <div class="list-content" v-if="listbyyouread.list.length > 0">
      <div class="other_title" @click="goList(listbyyouread)">
        <span>{{ listbyyouread.title }}</span>
        <div class="other_more">
          <span>更多</span>
          <img src="../../../static/forward.png" alt="" />
        </div>
      </div>
      <div
        v-for="(item, index) in listbyyouread.list"
        :key="index"
        @click="goDetail(item)"
      >
        <listItem :itemChild="item"></listItem>
      </div>
    </div>
    <div class="list-content" v-if="banner.list.length > 0">
      <div class="other_title" @click="goList(banner)">
        <span>{{ banner.title }}</span>
        <div class="other_more">
          <span>更多</span>
          <img src="../../../static/forward.png" alt="" />
        </div>
      </div>
      <div class="scrollSwiper">
        <div
          class="swiper-item"
          v-for="(item, index) in banner.list"
          :key="index"
          @click="goDetail(item)"
        >
          <img :src="item.bookLogoUrl" alt="" />
          <span class="swiper-title">{{ item.bookName }}</span>
          <span class="swiper-people">{{ item.studyingVolume }}万热度</span>
        </div>
      </div>
    </div>
    <div class="button-read" @click="goRead(false)">
      <span>立即阅读</span>
    </div>
    <qCode
      :qcodeUrl="qcodeUrl"
      :isShowQcode="isShowQcode"
      @eventChange="eventChange"
    ></qCode>
    <buyBook
      :showBuyMask="showBuyMask"
      :countCurrency="countCurrency"
      @buyChange="buyChange"
      :userCurrency="userCurrency"
    ></buyBook>
  </div>
</template>
<script>
// let App = getApp();
import wx from "weixin-js-sdk";
import { Toast, MessageBox } from "mint-ui";
import listItem from "../components/list-item.vue";
import bookCover from "./component/bookCover.vue";
import arrorImg from "../../components/arrow-img.vue";
import qCode from "../bookRead/component/qcode.vue";
import navBar from "../components/navbar.vue";
import buyBook from "../components/buyBook.vue";
export default {
  name: "bookDetail",
  components: {
    bookCover,
    listItem,
    arrorImg,
    qCode,
    navBar,
    buyBook,
  },
  data() {
    return {
      countCurrency: 0, //整本书币，
      showBuyMask: false, //显示整本订购弹窗
      userCurrency: 0, //用户剩余书币
      purchaseWholeBook: 0,
      bookId: 0,
      bookInfo: {
        bookLogoUrl: "",
        bookName: "",
        studyingVolume: 0,
        bookAuthor: "",
        bookFinish: 1,
        category: "",
        bookSummary: "",
        numChapters: 1,
        lastChapterName: "",
      },
      cataitem: {
        //书籍阅读到某个章节详情
        chapterContent: "",
        chapterId: 0,
        chapterName: "",
        chapterOrder: 1,
      },
      //其它作品
      listbyyouread: {
        title: "该作者其它作品",
        list: [],
      }, //喜欢这本书的人还喜欢
      banner: {
        title: "喜欢这本书的人还喜欢",
        list: [],
      },
      pageType: "",
      isReload: false,
      shareContent: "",
      qcodeUrl: "",
      isShowQcode: false,
      isEntranceData: "",
      isLastChapter: 0,
    };
  },
  watch: {
    $route: {
      // 监听路由的参数变化
      handler(val, old) {
        // 数据变化更新数据
        if (val.name == "bookDetail" && old.name == "bookDetail") {
          this.bookId = this.$route.query.bookId;
          this.getDetail();
        }
      },
    },
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    if (from.name == "bookRead" && to.name == "bookDetail") {
      to.meta.isBack = true;
      to.meta.keepAlive = true;
    } else {
      to.meta.isBack = false;
      to.meta.keepAlive = true;
    }
 
    next();
  },
  activated() {
      //监听页面加载
      this.bookId = this.$route.query.bookId;
      this.pageType = this.$route.query.pageType;
      this.isEntranceData = this.$route.query.isEntranceData
        ? this.$route.query.isEntranceData
        : "";
      var openid = this.$base.getStorage("openid");
      var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
      var city = this.$base.getStorage("city");
      if (!openid) {
        //静默登录手动登录
      } else if (
        isWxAuthorized == 0 &&
        city == 1 &&
        openid &&
        !this.$store.state.user.isSNS
      ) {
        this.$commonApi.snsapiUserinfo();
        this.getDetail();
        this.$base.setStorage("isSNS", true);
        this.$store.state.user.isSNS = true;
      } else {
        this.getDetail();
      }
      this.getOrderStatus();
      this.$commonApi.setTitle();
    if(!this.$route.meta.isBack){
        this.insertPageAccessData();
    }
  },
  methods: {
    getOrderStatus() {
      if (
        this.$base.getStorage("orderNum") &&
        this.$base.getStorage("isActivity")
      ) {
        var params = {
          orderNo: this.$base.getStorage("orderNum"),
          currentPageType: 1,
        };
        this.$api.getOrderStatus(params).then((res) => {
          this.$base.removeStorage("orderNum");
          this.$base.removeStorage("isActivity");
          if (res.status == 1) {
            Toast({
              message: res.message,
            });
          }
        });
      }
    },
    eventChange() {
      this.isShowQcode = false;
    },
    buyChange(data) {
      if (data) {
        if (data == 1) {
          this.purchaseWholeBook = 1;
          this.goRead(false);
        } else if (data == 2) {
          this.showBuyMask = false;
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              bookId: this.bookId,
              needCurrency: this.countCurrency,
              pageType: "bookRead",
            },
          });
        }
      } else {
        this.showBuyMask = false;
      }
    },
    goRead(flag) {
      // // 跳转到阅读器
      var params = {
        bookId: this.bookId,
        chapterId: this.cataitem.chapterId, //章节排序order
        chapterorder: this.cataitem.chapterOrder, //翻页标示 0:获取当前章节内容 1: 前一章 2：后一章,4从目录进入阅读器,3购买章节
        order: flag ? 2 : 0,
        booktype: "",
        isauto: 0,
        rechargeOrderNum: "", //订单编号
        purchaseWholeBook: this.purchaseWholeBook,
        currentPageType: 1,
      };
      this.$api.findChapterContentByChapterId(params).then((res) => {
        if (res.status == 1) {
          this.showBuyMask = false;
          this.purchaseWholeBook = 0;
          if (flag) {
            this.$router.push({
              path: "/pages/bookRead/index",
              query: {
                bookid: this.bookInfo.id,
                item: JSON.stringify({
                  chapterOrder: this.cataitem.chapterOrder,
                  chapterId: this.cataitem.chapterId,
                }),
                isDetail_Next: 1,
                pageType: "bookDetail",
                isEntranceData: this.isEntranceData + "-书籍详情",
              },
            });
          } else {
            this.$router.push({
              path: "/pages/bookRead/index",
              query: {
                bookid: this.bookId,
                pageType: "bookDetail",
                isEntranceData: this.isEntranceData + "-书籍详情",
              },
            });
          }
        } else if (res.status == 3) {
          this.showBuyMask = true;
          this.countCurrency = res.data.wholeBookCurrency;
          this.userCurrency = res.data.accountCurrency;
        } else if (res.status == 100 || res.status == 200||res.status==4) {
          if (res.data) {
            if(res.status==100&&res.data.priceType==3){
              this.$router.push({
                path: "/pages/bookCharge/index",
                query: {
                  bookId: this.bookId,
                  chapterId: res.data.id,
                  needCurrency: res.data.chapterPrice,
                  pageType: "bookRead",
                  priceType:res.data.priceType
                },
              });
              }else{
                this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId:this.bookId,
                  pageType: "bookDetail",
                },
              });
              } 
          }
        }
      });
    },
    getDetail() {
      var params = {
        bookId: this.bookId,
      };
      this.$api.getBookInfo(params).then((res) => {
        if (res.status == 1) {
          window.scrollTo(0, 0);
          var num = (res.data.bookInfoDTO.studyingVolume / 10000).toFixed(2);
          if (num >= 999.99) {
            res.data.bookInfoDTO.studyingVolume = 999.99;
          } else {
            res.data.bookInfoDTO.studyingVolume = num;
          }
          this.cataitem = res.data.latelyReading;
          this.bookInfo = res.data.bookInfoDTO;
          this.isLastChapter = res.data.isLastChapter;
          this.shareContent = res.data.shareContent;
          this.share();
          if (this.bookInfo.bookStatus == 2) {
            Toast({
              message: "书籍不存在",
            });
            setTimeout(() => {
              this.$base.setStorage("tabbarIndex", 1);
              this.$router.push({
                path: "/",
              });
            }, 200);
          }

          this.getAuthorBooks();
          this.getGuessYourLikeList();
        }
      });
    },
    share() {
      var realUrl = window.location.href;
      this.$api.getSignature({ realUrl: realUrl }).then((res) => {
        if (res.status == 1) {
          this.jweixinShare(res.data);
        }
      });
    },
    jweixinShare(data) {
      var that = this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: data.jsApiList, // 必填，需要使用的JS接口列表
      });
      var linkUrl = window.location.origin + "/" + window.location.hash;
      wx.ready(() => {
        wx.updateAppMessageShareData({
          //测试分享到朋友
          title: that.bookInfo.bookName, // 标题
          desc: that.shareContent, // 不是书籍描述
          link: linkUrl,
          imgUrl: that.bookInfo.bookLogoUrl,
          success: () => {
          },
        });
      });
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    },
    insertPageAccessData() {
      var prevPage = "";
      if (this.pageType == "bookCity") {
        prevPage = "书城";
      } else if (this.pageType == "bookClass") {
        prevPage = "分类";
      } else if (this.pageType == "bookSort") {
        prevPage = "排行榜";
      } else if (this.pageType == "bookFree") {
        prevPage = '限时免费'; //'限时免费'
      } else if (this.pageType == "bookRecommandread") {
        prevPage = '章末推荐'; 
      } else if (this.pageType == "bookSearch") {
        prevPage = "搜索";
      } else if (this.pageType == "bookRecharge") {
        prevPage = "充值中心";
      }
      var params = {
        pageName: "书籍详情",
        pageRemark: "上级页面：" + prevPage + ";书籍ID：" + this.bookId,
        isEntranceData: this.isEntranceData + "-书籍ID：" + this.bookId,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    getAuthorBooks() {
      var params = {
        bookAuthor: this.bookInfo.bookAuthor,
        pageNo: 1,
        pageSize: 10,
      };
      this.$api.getAuthorBooks(params).then((res) => {
        if (res.status == 1) {
          res.data.forEach((obj, index) => {
            var num = (obj.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              obj.studyingVolume = 999.99;
            } else {
              obj.studyingVolume = num;
            }
          });
          res.data.forEach((obj, index) => {
            if (obj.id == this.bookId) {
              res.data.splice(index, 1);
            }
          });
          this.listbyyouread.list = res.data;
        }
      });
    },
    getGuessYourLikeList() {
      var params = {
        bookId: this.bookId,
        category: this.bookInfo.category,
        booktype: "",
        pageNo: 1,
        pageSize: 10,
        isBookDetail: 1,
      };
      this.$api.getGuessYourLikeList(params).then((res) => {
        if (res.status == 1) {
          res.data.forEach((obj) => {
            var num = (obj.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              obj.studyingVolume = 999.99;
            } else {
              obj.studyingVolume = num;
            }
          });
          this.banner.list = res.data;
        }
      });
    },
    goDetail(item) {
      this.$router.push({
        path: "/pages/bookDetail/index",
        query: { bookId: item.id, pageType: "bookDetail" },
      });
    },
    goList(obj) {
      this.$router.push({
        path: "/pages/bookList/index",
        query: {
          title: obj.title,
          bookId: this.bookId,
          category: this.bookInfo.category,
          bookAuthor: this.bookInfo.bookAuthor,
        },
      });
    },
  },
};
</script>
<style scoped>
.contaner {
  padding-bottom: calc(44px + env(safe-area-inset-bottom));
}
.list-content {
  padding: 0px 16px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.other_title {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.other_title > span {
  display: block;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}

.other_title img {
  width: 8px;
  height: 15px;
  margin-left: 8px;
}

.other_more {
  display: flex;
}

.other_more > span {
  font-size: 12px;
  color: #aaaaaa;
}

.scrollSwiper {
  display: flex;
  overflow-x: scroll;
  margin-top: 20px;
}

.scrollSwiper::-webkit-scrollbar {
  width: 0 !important;
}

.swiper-item {
  margin-right: 16px;
}

.swiper-item img {
  width: 96px;
  height: 128px;
  display: block;
  border-radius: 6px;
}

.swiper-item span {
  display: block;
}

.swiper-title {
  font-size: 14px;
  color: #333333;
  margin-top: 10px;
  margin-bottom: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 96px;
}

.swiper-people {
  font-size: 12px;
  color: #de3b34;
}

.button-read {
  position: fixed;
  bottom: 0px;
  background-color: #de3b34;
  text-align: center;
  width: 100%;
  padding: 11px 0px;
  left: 0;
}

.button-read > span {
  font-size: 14px;
  color: #ffffff;
}
.list-content {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/bookDetail/index.vue